$(window).on('resize', function() {
  recalculateTabWrapper();
});

function recalculateTabWrapper() {
  let left_position = ($(window).width() - $('.tab-main-content-wrapper').first().width() * 1.67) / 2;

  $('.tab-main-content-wrapper').each(function (index, value) {
    $(value).css('margin-left', '-' + left_position + 'px');
    $(value).css('padding-left', left_position + 'px');
    $(value).css('width', 'calc(60% + ' + left_position + 'px)');
  });

  $('.subtabs-wrapper').each(function(index, value) {
    $(value).css('margin-left', '-' + left_position + 'px');
    $(value).css('padding-left', left_position + 'px');
  });
}

$(document).ready(function() {
  recalculateTabWrapper();
});

$('.vc_tta-tab > a').on('click', function() {
  $('.slider-tab-button a').removeClass('active-tab');
  $('.slider-tab-button a[href="' + $(this).attr('href') + '"]').addClass('active-tab');
});

$('.slider-tab-button').parent().find('.slider-tab-button:first-child a').addClass('active-tab');

$('.button-tab-next a, .button-previous a, .slider-tab-button a').on('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  $('.slider-tab-button a').removeClass('active-tab');
  $('.slider-tab-button a[href="' + $(this).attr('href') + '"]').addClass('active-tab');

  let target = $('.vc_tta-tab > a[href="' + $(this).attr('href') + '"]');

  $('html, body').animate({scrollTop: target.offset().top - 100}, 200);
  target.click();
});



// WEBPACK FOOTER //
// ./scripts/wpbakery/tabs.js